export const INVITE_ROLES = ['user', 'host', 'tutor'] as const;

export type InviteRole = (typeof INVITE_ROLES)[number];

export function isInviteRole(value: string | null | undefined): value is InviteRole {
  return INVITE_ROLES.includes(value as InviteRole);
}

export function parseInviteRole(value: string | null | undefined): InviteRole | null {
  return isInviteRole(value) ? value : null;
}

export function inviteCompletePath(role: InviteRole): string {
  return `/invite/${role}/complete`;
}

export function inviteRegisterPath(role: InviteRole): string {
  return `/invite/${role}`;
}
